import { jsx as _jsx } from "react/jsx-runtime";
import WhatsNewPageItemsList from "components/pages/whats-new/whats-new-items-list-component/whats-new-items-list";
import { StyledWhatsNewItemsListEmbeddedComponent } from "./whats-new-items-list-embedded-component.scss";
import { staticMondayConfig } from "./consts";
import { createItemsArray } from "/components/pages/whats-new/utils";
const filterLastYear = (items)=>{
    const now = new Date();
    const lastYearStart = new Date(now.getFullYear() - 1, now.getMonth(), 1);
    return items.filter((item)=>item.rawDate && item.rawDate >= lastYearStart);
};
const WhatsNewItemsListEmbeddedComponent = (props)=>{
    var _mondayConfigToUse_data_boards__items_page, _mondayConfigToUse_data_boards_, _mondayConfigToUse_data_boards, _mondayConfigToUse_data;
    const { productFilterValue, hideProductFilter, dynamicProps: { mondayConfig } = {} } = props;
    const mondayConfigToUse = mondayConfig || staticMondayConfig;
    const items = mondayConfigToUse === null || mondayConfigToUse === void 0 ? void 0 : (_mondayConfigToUse_data = mondayConfigToUse.data) === null || _mondayConfigToUse_data === void 0 ? void 0 : (_mondayConfigToUse_data_boards = _mondayConfigToUse_data.boards) === null || _mondayConfigToUse_data_boards === void 0 ? void 0 : (_mondayConfigToUse_data_boards_ = _mondayConfigToUse_data_boards[0]) === null || _mondayConfigToUse_data_boards_ === void 0 ? void 0 : (_mondayConfigToUse_data_boards__items_page = _mondayConfigToUse_data_boards_.items_page) === null || _mondayConfigToUse_data_boards__items_page === void 0 ? void 0 : _mondayConfigToUse_data_boards__items_page.items;
    const itemsArrayObj = createItemsArray(items);
    const itemsArray = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.itemsArray) || [];
    const itemsArrayLastYear = filterLastYear(itemsArray);
    const monthlyVideosSet = (itemsArrayObj === null || itemsArrayObj === void 0 ? void 0 : itemsArrayObj.monthlyVideosSet) || {};
    return /*#__PURE__*/ _jsx(StyledWhatsNewItemsListEmbeddedComponent, {
        className: "whats-new-items-list-embedded-component",
        children: /*#__PURE__*/ _jsx(WhatsNewPageItemsList, {
            itemsArray: itemsArrayLastYear,
            productFilterValue: productFilterValue,
            monthlyVideosSet: monthlyVideosSet,
            hideProductFilter: hideProductFilter
        })
    });
};
export default WhatsNewItemsListEmbeddedComponent;
